import { Card } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CommitChart from "./CommitChart";
import LinesAddedChart from "./LinesAddedChart";

function GitDashboardChart() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [projects, setProjects] = useState([]);
    const [users, setUsers] = useState([]);

    const {
        status: gitUserStatus,
        data: gitUserRes,
        refetch: getGitUsers,
    } = useQuery(
        "gitUsers",
        async () => await HTTP("/analytics/getGitUsers", { staff_id }),
        { enabled: false },
    );

    const {
        status: gitProjectStatus,
        data: gitProjectRes,
        refetch: getGitProjects,
    } = useQuery(
        "gitProjects",
        async () => await HTTP("/analytics/getGitProjects", { staff_id }),
        { enabled: false },
    );

    useEffect(() => {
        getGitUsers();
        getGitProjects();
    }, []);

    useEffect(() => {
        if (gitProjectStatus === "success") setProjects(gitProjectRes.data);
    }, [gitProjectStatus, gitProjectRes]);

    useEffect(() => {
        if (gitUserStatus === "success") setUsers(gitUserRes.data);
    }, [gitUserStatus, gitUserRes]);

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <div
                style={{
                    padding: "16px 0",
                    display: "flex",
                    flexDirection: "column",
                    gap: 0,
                }}
            >
                <LinesAddedChart projects={projects} users={users} />
                <CommitChart projects={projects} users={users} />
            </div>
        </Card>
    );
}

export { GitDashboardChart };
